import { AutoCompleteOption } from '@modules/common/components/AutoCompleteOption';
import { Option } from '@modules/queryBuilder/types';
import { TextFieldsRounded } from '@mui/icons-material';
import { Box, Stack } from '@mui/material';

interface QueryFilterNLSSearchTermOptionProps {
  option: Option;
  inputValue: string;
  selected: boolean;
  baseProps: React.HTMLAttributes<HTMLLIElement>;
}

export const QueryFilterNLSSearchTermOption = ({
  option,
  inputValue,
  selected,
  baseProps,
}: QueryFilterNLSSearchTermOptionProps) => {
  return (
    <Stack direction="row" alignItems="center" key={option.id}>
      <AutoCompleteOption
        key={option.id}
        option={{
          id: inputValue,
          displayName: inputValue,
        }}
        baseProps={baseProps}
        searchTerm={inputValue}
        selected={selected}
        renderLabelAvatar={() => (
          <Stack
            direction="row"
            alignItems="center"
            sx={{ pr: 1 }}
            minWidth="100%"
          >
            <Box sx={{ pr: 2 }}>
              <TextFieldsRounded color="primary" />
            </Box>
            <Box>{option.displayName}</Box>
          </Stack>
        )}
      />
    </Stack>
  );
};
